// extracted by mini-css-extract-plugin
export var colText = "featured-static-module--colText--6333d";
export var gatsbyImageWrapper = "featured-static-module--gatsby-image-wrapper--7daf9";
export var imageLink = "featured-static-module--imageLink--53b9f";
export var links = "featured-static-module--links--2b77b";
export var oneColumn = "featured-static-module--oneColumn--50f68";
export var playVideo = "featured-static-module--playVideo--7369c";
export var sectionOneColumn = "featured-static-module--sectionOneColumn--823db";
export var textImage = "featured-static-module--textImage--ee6bc";